import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import {getToken, removeToken} from "@/utils/auth";
import { ElMessage } from 'element-plus'
import PayRecord from '@/views/PayRecord.vue'
import DownloadRecord from '@/views/DownloadRecord.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    path: "/404",
    component: () => import("@/views/error/404.vue"),
  },
  {
    path: "/",
    name: "yin-container",
    component: () => import("@/views/YinContainer.vue"),
    children: [
      {
        path: "/member-center",
        name: "member-center",
        component: () => import("@/views/member-center/MembershipOrder.vue"),
      },
        {
        path: "/song-sheet",
        name: "song-sheet",
        component: () => import("@/views/song-sheet/SongSheet.vue"),
      },
      {
        path: "/",
        name: "home",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/sign-in", // 登录
        name: "sign-in",
        component: () => import("@/views/SignIn.vue"),
      },
      {
        path: "/sign-up", // 注册
        name: "sign-up",
        component: () => import("@/views/SignUp.vue"),
      },
      {
        path: "/personal",
        name: "personal",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/personal/Personal.vue"),
      },
      {
        path: "/song-sheet",
        name: "song-sheet",
        component: () => import("@/views/song-sheet/SongSheet.vue"),
      },
      {
        path: "/song-sheet-detail/:id",
        name: "song-sheet-detail",
        component: () => import("@/views/song-sheet/SongSheetDetail.vue"),
      },
      {
        path: "/singer",
        name: "singer",
        component: () => import("@/views/singer/Singer.vue"),
      },
      {
        path: "/singer-detail/:id",
        name: "singer-detail",
        component: () => import("@/views/singer/SingerDetail.vue"),
      },
      {
        path: "/lyric/:id",
        name: "lyric",
        component: () => import("@/views/Lyric.vue"),
      },
      {
        path: "/search",
        name: "search",
        component: () => import("@/views/search/Search.vue"),
      },
      {
        path: "/personal-data",
        name: "personal-data",
        component: () => import("@/views/setting/PersonalData.vue"),
      },
      {
        path: "/FPassword",
        name: "FPassword",
        component: ()=> import("@/views/FPassword.vue"),
      },
      {
        path: "/loginByemail",
        name: "loginByemail",
        component: ()=> import("@/views/loginByemail.vue"),
      },
      {
        path: "/setting",
        name: "setting",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/setting/Setting.vue"),
        children: [
          {
            path: "/setting/PersonalData",
            name: "personalData",
            meta: {
              requireAuth: true,
            },
            component: () => import("@/views/setting/PersonalData.vue"),
          }
        ]
      },
      {
        path: '/pay-record',
        name: "pay-record",
        component: PayRecord
      },
      {
        path: '/download-record',
        name: "download-record",
        component: DownloadRecord
      },
      {
        path: '/song-style',
        name: 'SongStyle',
        component: () => import('@/views/song-style/SongStyleList.vue')
      },
      {
        path: '/song-cycle',
        name: 'SongCycle',
        component: () => import('@/views/song-style/SongCycleList.vue')
      },
      {
        path: '/my-collection',
        name: 'MyCollection',
        component: () => import('@/views/MyCollection.vue')
      },
      {
        path: '/singer-list',
        name: 'SingerList',
        component: () => import('@/views/singer/SingerList.vue')
      },
      // 入驻平台
      {
        path: "/entryPlatform",
        name: "entryPlatform",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/entryPlatform/platformHome.vue")
      },
        // 入驻音乐人资料填写
      {
        path: "/entryPlatform/platformInfo",
        name: "platformInfo",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/entryPlatform/platformInfo.vue"),
      },
      {
        path: "/songPackage/SongPackageList",
        name: "songPackageList",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/songPackage/SongPackageList.vue"),
      },
      {
        path: "/songPackage/SongPackageDetail",
        name: "songPackageDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("@/views/songPackage/SongPackageDetail.vue"),
      }
    ],
  },
  {
    path: "/userMusicManage",
    name: "userMusicManage",
    component: () => import("@/views/userMusicManage/Home.vue"),
    children: [
      {
        path: "/userMusicManage/Home",
        name: "Home",
        component: () => import("@/views/userMusicManage/Home.vue"),
      },
      {
        path: "/userMusicManage/userCenter",
        name: "userCenter",
        component: () => import("@/views/userMusicManage/userCenter.vue"),
      },
        // 单曲
      {
        path: "/userMusicManage/uploadSong",
        name: "uploadSong",
        component: () => import("@/views/userMusicManage/uploadSong.vue"),
      },
      {
        path: "/userMusicManage/songReviewHistory",
        name: "songReviewHistory",
        component: () => import("@/views/userMusicManage/songReviewHistory.vue"),
      },
      {
        path: "/userMusicManage/songList",
        name: "songList",
        component: () => import("@/views/userMusicManage/songList.vue"),
      },
      // 套曲
      {
        path: "/userMusicManage/uploadSongCycle",
        name: "uploadSongCycle",
        component: () => import("@/views/userMusicManage/uploadSongCycle.vue"),
      },
      {
        path: "/userMusicManage/songCycleReviewHistory",
        name: "songCycleReviewHistory",
        component: () => import("@/views/userMusicManage/songCycleReviewHistory.vue"),
      },
      {
        path: "/userMusicManage/songCycleList",
        name: "songCycleList",
        component: () => import("@/views/userMusicManage/songCycleList.vue"),
      },
      {
        path: "/userMusicManage/userFans",
        name: "userFans",
        component: () => import("@/views/userMusicManage/userFans.vue"),
      },
      {
        path: "/userMusicManage/userIdol",
        name: "userIdol",
        component: () => import("@/views/userMusicManage/userIdol.vue"),
      },
      {
        path: "/userMusicManage/orderList",
        name: "orderList",
        component: () => import("@/views/userMusicManage/orderList.vue"),
      },
      {
        path: "/userMusicManage/withdrawMoney",
        name: "withdrawMoney",
        component: () => import("@/views/userMusicManage/withdrawMoney.vue"),
      },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
/*  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置，则使用保存的位置
    /!*if (savedPosition) {
      return savedPosition;
    }*!/
    // 否则滚动到顶部
    return { top: 0 };
  }*/
  scrollBehavior(to, from, savedPosition) {
    // 特殊处理嵌套路由的首页
    if (to.path === '/' || to.matched.some(record => record.path === '/')) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ top: 0 })
        }, 300) // 等待300ms确保组件加载完成
      })
    }
    return savedPosition || { top: 0 }
  }

});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = getToken();
  const publicPaths = [
    '/',
    '/sign-up',
    '/sign-in',
    '/song-sheet',
    '/singer',
    '/lyric',
    '/search',
    '/FPassword',
    '/loginByemail',
    '/member-center',
  ];
  const isPublicPath = publicPaths.some(path => to.path.startsWith(path));
  if (!token && !isPublicPath) {
    // 不存在 token 并且访问的不是 登录页面则重定向到登录页面
    next('/');
    ElMessage({
      message: '请先登录',
      type: 'warning',
    })
    removeToken();
  } else if (token && to.path === '/') {
    // 存在 token 并且访问的页面是登录页面的情况下则重定向到首页
    next();
  } else {
    // 否则继续导航到目标路由
    next();
  }
});

export default router;
